import { useQuery } from '@tanstack/react-query';
import { createSubscriptionQuery } from 'shared/lib/@tanstack-query';
import { getSmartListsQuery } from 'shared/services/backend-api/get-smart-lists';
import { ID } from 'shared/types/id';

export const queryKey = 'smart-lists';

export const useSmartListsQuery = (uid?: ID) =>
  useQuery({
    queryKey: [queryKey, uid ?? ''],
    queryFn: createSubscriptionQuery([() => getSmartListsQuery(uid!)]),
    enabled: !!uid,
  });
